// GraphQL queries and mutations for Subscriptions (proxy membership API)

export const listSubscriptionsQuery = `
  query ListSubscriptions($input: ListSubscriptionsInput!) {
    listSubscriptions(input: $input) {
      code
      subscriptionList {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        activatedBy
        activatedAt
        createdAt
        updatedAt
      }
    }
  }
`;

/** Super admin: list all subscriptions with search, filter, and pagination. */
export const listAllSubscriptionsSuperAdminQuery = `
  query ListAllSubscriptionsSuperAdmin($input: ListAllSubscriptionsSuperAdminInput) {
    listAllSubscriptionsSuperAdmin(input: $input) {
      code
      subscriptionList {
        subscriptionId
        companyId
        companyAdminEmail
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        createdAt
        updatedAt
      }
      totalElements
      totalPages
      number
      size
    }
  }
`;

/** Super admin: list subscriptions for a company (companyId in request). */
export const listSubscriptionsSuperAdminQuery = `
  query ListSubscriptionsSuperAdmin($companyId: String!) {
    listSubscriptionsSuperAdmin(companyId: $companyId) {
      code
      subscriptionList {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        activatedBy
        activatedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const getSubscriptionQuery = `
  query GetSubscription($input: GetSubscriptionInput!) {
    getSubscription(input: $input) {
      code
      subscription {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        activatedBy
        activatedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const createSubscriptionMutation = `
  mutation CreateSubscription($input: CreateSubscriptionInput!) {
    createSubscription(input: $input) {
      code
      subscriptionId
    }
  }
`;

export const cancelSubscriptionMutation = `
  mutation CancelSubscription($input: CancelSubscriptionInput!) {
    cancelSubscription(input: $input) {
      code
      subscription {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        activatedBy
        activatedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const resumeSubscriptionMutation = `
  mutation ResumeSubscription($subscriptionId: String!) {
    resumeSubscription(subscriptionId: $subscriptionId) {
      code
      subscription {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        activatedBy
        activatedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const pauseSubscriptionMutation = `
  mutation PauseSubscription($subscriptionId: String!) {
    pauseSubscription(subscriptionId: $subscriptionId) {
      code
      subscription {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        activatedBy
        activatedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const extendSubscriptionMutation = `
  mutation ExtendSubscription($subscriptionId: String!, $subscriptionEndsAt: String!) {
    extendSubscription(subscriptionId: $subscriptionId, subscriptionEndsAt: $subscriptionEndsAt) {
      code
      subscription {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        activatedBy
        activatedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const activateSubscriptionMutation = `
  mutation ActivateSubscription($subscriptionId: String!, $subscriptionEndsAt: String) {
    activateSubscription(subscriptionId: $subscriptionId, subscriptionEndsAt: $subscriptionEndsAt) {
      code
      subscription {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        activatedBy
        activatedAt
        createdAt
        updatedAt
      }
    }
  }
`;
